import React from 'react'
import { type GetInterviewDto } from '../../api/ic'
import InterviewTypeImg from '../img/InterviewTypeImg'
import { COLORS } from '../../util/Consts'
import { FONT_MODES } from '../modes/FontMode'
import StarIcon from '@mui/icons-material/Star'

interface RecordingCardInterface {
  obj: GetInterviewDto
  averagePoints: number
}
function getFullName (obj: GetInterviewDto) {
  const { firstName, lastName, email } = obj.giver

  const isInvalid = (value: any) => value?.includes('@')

  if (isInvalid(firstName) || isInvalid(lastName)) {
    return email
  }

  return `${firstName} ${lastName}`
}
function RecordingCard (props: RecordingCardInterface) {
  return (
    <>
      <div>
        {/* eslint-disable-next-line @typescript-eslint/no-misused-promises */}
        <a style={{ cursor: 'pointer', textDecoration: 'none' }}>
          <div
            className="d-flex flex-row justify-content-between align-items-center"
            style={{
              position: 'relative',
              minHeight: '100px',
              maxHeight: '100px',
              borderRadius: '10px',
              background: '#FAFAFA',
              boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
              userSelect: 'none'
            }}>
            <InterviewTypeImg obj={{ ...props.obj, id: undefined }}/>
            <span style={{
              position: 'absolute',
              marginLeft: '10px',
              right: '-10px',
              top: '-10px',
              borderRadius: '5px',
              background: '#FFF',
              padding: '1px 6px 1px 6px',
              boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.25)',
              color: COLORS.MAIN_COLOR,
              display: 'flex',
              alignItems: 'center',
              gap: '3px'
            }}>
              <StarIcon style={{
                color: '#FFD700',
                fontSize: '1.2em'
              }}/>
              <span>
                {props.averagePoints.toFixed(2)}
                /5
              </span>
            </span>
            <div
              className="d-flex flex-column justify-content-center align-items-center"
              style={{
                maxWidth: '100%',
                flex: 1,
                borderRadius: '5px 10px 10px 5px',
                padding: '10px',
                overflow: 'hidden',
                height: '100px',
                background: COLORS.MAIN_COLOR
              }}>
              <span className="text-nowrap text-center"
                style={{
                  color: '#FFF',
                  width: '200px',
                  fontFamily: 'Inter, sans-serif',
                  fontSize: FONT_MODES.LARGE.browser,
                  fontStyle: 'normal',
                  fontWeight: '700',
                  lineHeight: '1.2',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis'
                }}>
                {props.obj.name}
              </span>
              <span className="text-nowrap text-center"
                style={{
                  color: '#FFF',
                  fontFamily: 'Inter, sans-serif',
                  fontSize: FONT_MODES.SMALL.scalar,
                  fontStyle: 'normal',
                  fontWeight: '300',
                  lineHeight: '1.5',
                  width: '200px',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis'
                }}>
                {getFullName(props.obj)}
              </span>
            </div>
          </div>
        </a>
      </div>
    </>
  )
}

export default RecordingCard
